import React, { useEffect, useRef } from 'react';
import { useLocation, Link, useNavigate, useParams } from 'react-router-dom';
import {connect} from 'react-redux';
import {
  AppBar,
  Box,
  Button,
  Divider,
  IconButton,
  useScrollTrigger,
  useMediaQuery
} from '@mui/material';
import { englishFontFallbackMap, arabicFontFallbackMap } from '../fonts';
import { motion, useCycle } from "framer-motion"
import { getUserCart } from 'src/store/action';
import { debounce } from 'lodash';
import { useState } from 'react';
import { makeStyles } from '@mui/styles';
import { ShoppingCartOutlined } from '@mui/icons-material';
import { useCompanyData } from '../contexts/DataContext';
import { change_lang } from '../../../../../store/action';
import { useDispatch } from 'react-redux';
import i18next from 'i18next';
import useRTL from 'src/hooks/useRTL';
import CustomizedMenus from'./ServiceListMenu';
import DropdownMenuItem from './DropdownMenuItem';
import MoreMenu from './MoreMenu';
import SectionLayout from '../layout/SectionLayout';
import ImgLazyLoad from 'src/screens/WhiteLabels/Templates/shared/components/ImgLazyLoad';
import UKFlag from 'src/assets/images/usa.svg';
import ARFlag from 'src/assets/images/saudi.jpeg';
import {  textClasses } from '../../shared/config';
import './navbar.css';

// mobile animated navbar utils start
const enSidebar = {
  open: (height = 1000) => {
    return  ({
      clipPath: `circle(${height * 2 + 200}px at 100% 0%)`,
      transition: {
        type: "spring",
        stiffness: 20,
        restDelta: 2
      }
    })
  }
    
  ,
  closed: {
    clipPath: "circle(0px at 100% 0px)",
    transition: {
      delay: 0.5,
      type: "spring",
      stiffness: 400,
      damping: 40
    }
  }
};
const arSidebar = {
  open: (height = 1000) => {
    return  ({
      clipPath: `circle(${height * 2 + 200}px at 40px 40px)`,
      transition: {
        type: "spring",
        stiffness: 20,
        restDelta: 2
      }
    })
  },

  closed: {
    clipPath: "circle(0px at 40px 40px)",
    transition: {
      delay: 0.5,
      type: "spring",
      stiffness: 400,
      damping: 40
    }
  }
};

const Path = props => (
  <motion.path
    fill="transparent"
    strokeWidth="3"
    stroke="hsl(0, 0%, 18%)"
    strokeLinecap="round"
    {...props}
  />
);

const variants = {
  open: {
    transition: { staggerChildren: 0.07, delayChildren: 0.2 }
  },
  closed: {
    transition: { staggerChildren: 0.03, staggerDirection: -1 }
  }
};

const menuItemVariants = {
  open: {
    y: 0,
    opacity: 1,
    transition: {
      y: { stiffness: 1000, velocity: -100 }
    }
  },
  closed: {
    y: 50,
    opacity: 0,
    transition: {
      y: { stiffness: 1000 }
    }
  }
};
// mobile animated navbar utils end

const useStyles = makeStyles({
  list: {
    width: 250,
  },

  mobileNav:props => ({
    alignItems: props.isRTL === 'ar' ? 'flex-end' : 'flex-start',
    padding:'0px 5px'
  }),

  drawerPaperRoot:props => ({
    backgroundColor: props?.menuBackgroundColor ? props.menuBackgroundColor : ''
  }),

  langBtn:{
    display: 'flex',
    flexDirection: 'row',
    backgroundColor: 'transparent',
    alignItems:'center',
    fontSize:'1rem',
    borderRadius:'4px',
    width:'100%',
    padding:'10.5px 14px',
    height: '41px',
    letterSpacing:'0.00938em'
  },

  langImg:{
    width:'27px',
    marginRight:'5px',
    display:'flex',
    flexDirection:'row',
    alignItems:'center',
    "& img":{
      width:'100%',
      height:'100%'
    }
  },

  menuBtn:props=>({
    backgroundColor: props.buttonColor ? props.buttonColor : '#fff',
    color: props.buttonFontColor ? props.buttonFontColor : '#000',
    minWidth: '30px',
    width: '30px',
    height:'29px',
    borderRadius: '2px',
    padding: '0px',
    marginLeft:'5px',
    marginRight:'5px',
  }),

  navItem:props => ({
    '&:hover':{
      color: `${props?.menuActiveFontColor} !important`,
    },
  }),

  imgHover:{
    transition:'all 0.4s ease',
    '&:hover':{
      opacity:0.6
    }
  },

  mobileLoginBtn:{
    outline:'none',
    textAlign:'center',
    border:'none',
    backgroundColor:'#0F467A',
    minHeight:'60px',
    maxHeight:'60px',
    minWidth:'150px',
    borderRadius:'5px',
    cursor:'pointer',
    whiteSpace:'nowrap',
    color:'#fff',
    fontSize:'18px'
  }

});

export const MyLink = ({
  isMobile,
  to,
  externalLink,
  children,
  hasActiveBorderClose,
  hasActiveBorder,
  hasActiveBorderTop,
  activeColor,
  defaultColor,
  menuFontColor,
  menuActiveFontColor,
  marginX,
  callback,
  moreMenu,
  ...props
}) => {

  const { data } = useCompanyData();
  const { i18n, buttonFontSize } = data || {};
  const classes = useStyles({menuActiveFontColor});
  const matches992 = useMediaQuery('(max-width:992px)');
  const location = useLocation();  
  const serviceId = location?.pathname?.split('/services/')[1];
  const isActive =
    location.pathname === to ||
    (location.pathname.search(`/services/${serviceId}`) !== -1 &&
      to.search(`/services/${serviceId}`) !== -1);

    const isRTL = i18n?.translator?.language;

    const fontSizeCls = buttonFontSize && textClasses?.[buttonFontSize] ? textClasses?.[buttonFontSize] : 'normal';

  return (
    <Box
      mr={matches992 ? 0 : "10px"}
      style={isRTL === 'en' ? {
        height: hasActiveBorderTop ? '100%' : 'auto',
        marginLeft:marginX,
        ...(matches992 ? {width:'100%',borderBottom:'1px solid rgb(229, 229, 229)'} : {
          borderTop: hasActiveBorderTop && isActive ? `4px solid ${menuActiveFontColor ? menuActiveFontColor : menuFontColor}` : '',
        }),
      } : 
      {
        ...(matches992 ? {width:'100%',borderBottom: '1px solid rgb(229, 229, 229)'} : {
          borderTop: hasActiveBorderTop && isActive ? `4px solid ${menuActiveFontColor ? menuActiveFontColor : menuFontColor}` : ''
        }),
        height: hasActiveBorderTop ? '100%' : 'auto',
        marginRight:marginX,
      }}
      whiteSpace="nowrap"
      {...(callback ? {onClick: callback} : {})}
    >
      {externalLink ?
      <a
        style={{
          textDecoration: 'none',
          color: matches992 ? '#000' : isMobile ? '#000' : menuFontColor ? menuFontColor : 'inherit',
          width: isMobile ? '100%' : 'auto',
        }}
        href={externalLink}
      >
        <Button
          variant="text"
          style={{
            padding: hasActiveBorderTop && !moreMenu ? '30px 11px' : matches992 ? '8px 0px' : '8px 11px',
            width: isMobile ? '100%' : 'auto',
            borderRadius:'0px',
            height: '100%',
            color: matches992 ? '#000' : isActive ?  menuActiveFontColor ? `${menuActiveFontColor} !important` : menuFontColor : (menuFontColor || defaultColor),
            borderBottom: hasActiveBorder && isActive ? `2px solid ${menuActiveFontColor ? menuActiveFontColor : menuFontColor}` : '',
            // color: isMobile ? '#000' :  menuFontColor ? menuFontColor : 'inherit',
            ...(matches992 ? {minWidth:'unset !important'} : {})
          }}
          {...props}
          className={`${classes.navItem} ${fontSizeCls}`}
        >
          <Box
            style={{borderBottom:hasActiveBorderClose ? isActive ? `2px solid ${menuActiveFontColor ? menuActiveFontColor : menuFontColor}` : '' : ''}}
          >
            <Box
              fontWeight={props.fontWeight || 500}
            >
              {children}
            </Box>
          </Box>
        </Button>
      </a>
      :
      <Link
        style={{
          textDecoration: 'none',
          color: matches992 ? '#000' : isActive ? menuActiveFontColor : (isMobile ? '#000' : menuFontColor || defaultColor),
          width: isMobile ? '100%' : 'auto',
        }}
        to={to}
        className={fontSizeCls}
      >
        <Button
          variant="text"
          style={{
            padding: hasActiveBorderTop && !moreMenu ? '30px 11px' : matches992 ? '8px 0px' : '8px 11px',
            width: isMobile ? '100%' : 'auto',
            height: '100%',
            borderRadius:'0px',
            color: matches992 ? '#000' : isActive ? menuActiveFontColor : (isMobile ? '#000' : menuFontColor || defaultColor),
            borderBottom:
              hasActiveBorder && isActive ? `2px solid ${menuActiveFontColor ? menuActiveFontColor : menuFontColor}` : '',
            ...(matches992 ? {minWidth:'unset !important'} : {})
          }}
          {...props}
          className={`${classes.navItem} ${fontSizeCls}`}
        >
          <Box
            style={{borderBottom: hasActiveBorderClose ? isActive ? `2px solid ${menuActiveFontColor ? menuActiveFontColor : menuFontColor}` : '' : ''}}
          >
            <Box
              // style={{color: isActive ? menuActiveFontColor ? `${menuActiveFontColor} !important` : (isMobile ? '#000' : menuFontColor || defaultColor) : (isMobile ? '#000' : menuFontColor || defaultColor)}}
              // color={isActive ?  activeColor ? menuFontColor : menuFontColor : (menuFontColor || defaultColor)}
              fontWeight={props.fontWeight || 500}
            >
              {children}
            </Box>
          </Box>
        </Button>
      </Link>
      }
    </Box>
  );
};

const NavLinks = ({
  logo,
  formData,
  setFormData,
  divider,
  direction,
  redirectRenew,
  activeColor,
  menuFontColor,
  menuActiveFontColor,
  ...props
}) => {
  const { pathname:url } = useLocation();
  const navigate = useNavigate();
  const { data } = useCompanyData();
  const { companyDomain } = data || {};
  const { user, company, t,isRTL, mainColor, menuLogoWidth, menuLogoHeight, buttonColor, buttonFontColor, buttonFontSize, buttonRadiusGeneral, showMenuLoginBtn= true, showMenuLangBtn= true} = data;
  const filterMenuList = data?.menuList?.filter(v=> v?.visible)?.splice(1) || [];
  const [isOverflow, setIsOverflow] = useState(false);
  const [showMore, setShowMore] = useState(false);
  const menuRef = React.useRef(null);

  const matches992 = useMediaQuery('(max-width:992px)');

  
  const originalMenu = filterMenuList?.length > 2 ? Array.from(filterMenuList) : [];
  const menuList = filterMenuList?.length > 2 ? Array.from(filterMenuList) : [];
  const menuList2 = filterMenuList?.length > 2 ? Array.from(filterMenuList) : [];
  const { company_id, cartList, get_user_cart } = props;
  const { id:userId } = user || {};
  const isParent = user && user.isParent;
  const companyId = company && company.id;
  const dispatch = useDispatch();
  const [, , fontFamily] = useRTL();
  const params = useParams();
  const { id: pathId } = params;
  const classes = useStyles({isRTL});
  const fontSizeCls = buttonFontSize && textClasses?.[buttonFontSize] ? textClasses?.[buttonFontSize] : 'normal';
  const matches1200 = useMediaQuery('(min-width:1400px)');
  const itemLength = matches1200 ? 5 : 3;
    const englishFont = englishFontFallbackMap[data?.englishFont] || "'Poppins', sans-serif";
    const arabicFont = arabicFontFallbackMap[data?.arabicFont] || '"Cairo", sans-serif';

  useEffect(() => {
    const checkOverflow = () => {
      if (menuRef.current) {
        setIsOverflow(menuRef.current.scrollWidth >= menuRef.current.offsetWidth);
      }
    };
  
    const debouncedCheckOverflow = debounce(checkOverflow, 300);
  
    window.addEventListener('resize', debouncedCheckOverflow);
    checkOverflow(); // Initial check
  
    return () => {
      window.removeEventListener('resize', debouncedCheckOverflow);
    };
  }, [data?.menuList]);
  
  const changeLanguage = (newLanguage) => {
    dispatch(change_lang(newLanguage));
    i18next.changeLanguage(newLanguage);
  };

  useEffect(()=> {
    get_user_cart({parentId:userId,companyId: companyId});
  },[userId,companyId])
  
  const redirectBooking = () => {
    const groupId = cartList.length > 0 ? cartList[0].groupId : '';
    const companyId = cartList.length > 0 ? cartList[0].companyId : '';
    if(companyId && groupId) navigate(`/booking/${company_id}/${groupId}`, { replace: true });
  }


  const renderMenuItem = (menuItem) => {
    const { englishName, arabicName, visible, externalLink, path, subMenu=[], id } = menuItem;
    const menuExist = subMenu ? subMenu?.filter(v => v?.visible) : false;
    if (!visible) return null; // Return early if not visible
  
    const title = isRTL === 'ar' ? arabicName : englishName;
    const linkPath = path ? companyDomain ? `/temp/${path}` : `/${pathId}/temp/${path}` : '';

    if(id === 'service-1') {
      return(
        <CustomizedMenus  {...props} menuActiveFontColor={menuActiveFontColor} menuFontColor={menuFontColor}/>
      )
    };
  
    if (menuExist?.length) {
      return (
        <DropdownMenuItem
          title={title}
          externalLink={externalLink}
          to={linkPath}
          menuFontColor={menuFontColor}
          menuActiveFontColor={menuActiveFontColor}
          subMenu={menuExist}
          {...props}
        />
      );
    };
  
    return (
      <MyLink
        externalLink={externalLink}
        to={linkPath}
        menuFontColor={menuFontColor}
        menuActiveFontColor={menuActiveFontColor}
        {...props}
      >
        {title}
      </MyLink>
    );
  };

  const mapMenuList = menuList?.splice(1,5);
  const addMenuList = menuList2?.splice(6);
  return (<>
    <Box
      fontFamily={'inherit'}
      height={props.isMobile ? 'auto' : '100%'}
      flexDirection={direction}
      className={props.isMobile ? classes.mobileNav : ''}
      justifyContent="space-between"
      width="100%"
      display={matches992 ? 'none' : 'flex'}
    >
      
      <Box display="flex" flexDirection="row" alignItems="center" ref={menuRef} width="calc(100% - 300px)">
        {/* desktop logo */}
        { logo && !props.isMobile ? (
          <Link to={companyDomain ? '/' : `/${pathId}`}
            style={{
              display:'flex',
              flexDirection:'column',
              alignItems:'center',
              justifyContent:'center',
              height:'100%',
              ...(isRTL === 'ar' ? {marginLeft:props.isMobile ? '0px' : '1.5rem'} : {marginRight:props.isMobile ? '0px' : '1.5rem'})
            }}
          >
            <Box
              pt={props.hasActiveBorder ? 1 : 0}
              cursor="pointer"
              overflow="hidden"
              {...(props.isMobile ? {mx: 'auto'} : {})}
            >
              <ImgLazyLoad>
                <img
                  src={logo}
                  alt="logo"
                  className={classes.imgHover}
                  style={{ height: '100%', maxHeight:'50px', verticalAlign:'middle' }}
                />
              </ImgLazyLoad>
            </Box>
          </Link>
        ) 
        : null }


        {/* desktop nav */}
        {/* {filterMenuList?.length > 0 ?  */}
          <Box display="flex" flexDirection={matches992 ? 'column' : "row"} style={matches992 ? {alignItems:'flex-start'} : {}} flexWrap="nowrap">
            <MyLink to={companyDomain ? '/' : `/${pathId}`} menuFontColor={menuFontColor} menuActiveFontColor={menuActiveFontColor} {...props}>
              {t && t('companyPage.home')}
            </MyLink>
            {!matches992 ?
              <>
                {filterMenuList.slice(0, isOverflow ? itemLength : filterMenuList.length).map(renderMenuItem)}
                {isOverflow && filterMenuList.slice(itemLength)?.length ? (
                  <MoreMenu 
                    _menuList={filterMenuList.slice(itemLength)}
                    menuFontColor={menuFontColor}
                    menuActiveFontColor={menuActiveFontColor}
                    {...props}
                  />
                ) : null}
              </>
            :
            React.Children.toArray(filterMenuList?.map(renderMenuItem))
            }
           
          </Box>
          {/* : 
          <>
            <MyLink to={companyDomain ? '/' : `/${pathId}`} menuActiveFontColor={menuActiveFontColor} menuFontColor={menuFontColor} {...props}>
              {t && t('companyPage.home')}
            </MyLink>
            <CustomizedMenus  menuFontColor={menuFontColor} {...props}/>
            <MyLink to={companyDomain ? `/temp/contact` : `/${pathId}/temp/contact`} menuActiveFontColor={menuActiveFontColor} menuFontColor={menuFontColor} {...props}>
              {t && t('companyPage.contact')}
            </MyLink>
          </>
        } */}
        </Box>

      <Box
        fontFamily={'inherit'}
        display="flex"
        flexDirection={'row'}
        alignItems="center"
        justifyContent="center"
        height={props.isMobile ? 'auto' : '100%'}
        className={props.isMobile ? classes.mobileNav : ''}
        gap="0.5rem"
      >

        {userId && cartList.length > 0 ?
        <Box my={1} whiteSpace="nowrap" onClick={redirectBooking}>
          <IconButton
            style={{color:buttonColor ? buttonColor : 'inherit',fontSize:'2rem'}}
            size="large">
            <ShoppingCartOutlined />
          </IconButton>
        </Box>
        :
        null }

        {showMenuLoginBtn ?
        <Box my={1} whiteSpace="nowrap">
          <Button variant="contained" color="primary" className={fontSizeCls} style={{color:buttonFontColor ? buttonFontColor : 'inherit',backgroundColor: buttonColor ? buttonColor : 'inherit',borderRadius: buttonRadiusGeneral ? `${buttonRadiusGeneral}px` : '0px'}} onClick={redirectRenew}>
            {t && t(isParent && companyId ? 'parentDashboard.myAccount2' : 'companyPage.login')}
          </Button>
        </Box>
        : null}

        {showMenuLangBtn ?
        <Box
          // width="fit-content"
          // maxWidth="150px"
          // minWidth="110px"
          my={1}
          textAlign={props.isMobile ? 'center' : 'left'}
          dir="ltr"
          whiteSpace="nowrap"
        >
          <button
            style={{
              color: `${buttonFontColor ? buttonFontColor : props.defaultColor}`,
              backgroundColor: buttonColor ? buttonColor : '#fff',
              border: `1px solid ${buttonColor ? buttonColor : '#17C799'}`,
              borderRadius: buttonRadiusGeneral ? `${buttonRadiusGeneral}px` : '0px',
              fontFamily: data?.isRTL === 'en' ? arabicFont : englishFont,
              cursor:'pointer',
              outline:'none'
            }}
            className={`${classes.langBtn} ${fontSizeCls}`}
            onClick={()=> changeLanguage(data.isRTL === 'en' ? 'ar' : 'en')}
          >
            <div className={classes.langImg}>
              <img src={data?.isRTL === 'ar' ? UKFlag : ARFlag} alt="change language" />
            </div>
            <span>{ data?.isRTL === 'ar' ? 'English' : 'عربي' }</span>
          </button>
        </Box>
        : null}
      </Box>
    </Box>
    {props.isMobile && <Divider />}
    {/* right side login buttons */}
    {/* <Box
      fontFamily={fontFamily}
      display="flex"
      flexDirection={direction}
      alignItems="center"
      justifyContent="center"
      height={props.isMobile ? 'auto' : '100%'}
      className={props.isMobile ? classes.mobileNav : ''}
      gap="0.5rem"
    >

      {userId && cartList.length > 0 ?
      <Box my={1} onClick={redirectBooking}>
        <IconButton
          style={{color:buttonColor ? buttonColor : 'inherit',fontSize:'2rem'}}
          size="large">
          <ShoppingCartOutlined />
        </IconButton>
      </Box>
      :
      null }

      {showMenuLoginBtn ?
      <Box my={1}>
        <Button variant="contained" color="primary" className={fontSizeCls} style={{color:buttonFontColor ? buttonFontColor : 'inherit',backgroundColor: buttonColor ? buttonColor : 'inherit',borderRadius: buttonRadiusGeneral ? `${buttonRadiusGeneral}px` : '0px'}} onClick={redirectRenew}>
          {t && t(isParent && companyId ? 'parentDashboard.myAccount2' : 'companyPage.login')}
        </Button>
      </Box>
      : null}

      {showMenuLangBtn ?
      <Box
        // width="fit-content"
        // maxWidth="150px"
        // minWidth="110px"
        my={1}
        textAlign={props.isMobile ? 'center' : 'left'}
        dir="ltr"
      >
        <button
          style={{
            color: `${buttonFontColor ? buttonFontColor : props.defaultColor}`,
            backgroundColor: buttonColor ? buttonColor : '#fff',
            border: `1px solid ${buttonColor ? buttonColor : '#17C799'}`,
            borderRadius: buttonRadiusGeneral ? `${buttonRadiusGeneral}px` : '0px',
            fontFamily: data?.isRTL === 'en' ? "'Cairo', sans-serif" : "'Poppins', sans-serif",
            cursor:'pointer',
            outline:'none'
          }}
          className={`${classes.langBtn} ${fontSizeCls}`}
          onClick={()=> changeLanguage(data.isRTL === 'en' ? 'ar' : 'en')}
        >
          <div className={classes.langImg}>
            <img src={data?.isRTL === 'ar' ? UKFlag : ARFlag} alt="change language" />
          </div>
          <span>{ data?.isRTL === 'ar' ? 'English' : 'عربي' }</span>
        </button>
      </Box>
      : null}
    </Box> */}
  </>);
};

const Navbar = ({
  formData,
  setFormData,
  position = 'static',
  bgcolor= "#fff",
  ...props
}) => {
  const { transparencyColor } = props;
  const [_isOpen, setIsOpen] = useState(false);
  const [isOpen, toggleOpen] = useCycle(false, true);
  const containerRef = useRef(null);
  const { height } = useDimensions(containerRef);
  const { data } = useCompanyData();
  const navigate = useNavigate();
  const { id:pathId } = useParams();
  const { isRTL, user, company, set_companyId, menuBackgroundColor, menuFontColor, menuActiveFontColor, menuLogoWidth, menuLogoHeight, displayMenuOverHeader, buttonColor, buttonFontColor, companyDomain } = data;
  const classes = useStyles({menuBackgroundColor,buttonColor,buttonFontColor});
  const { pathname:url } = useLocation();
  const matches992 = useMediaQuery('(max-width:992px)');
  const logo = data?.companyData?.avatar;
  const redirectRenew = () => {
    const isParent = user && user.isParent;
    const companyId = company && company.id;
    if(isParent && companyId) {
        set_companyId(companyId);
        navigate(`/dashboard`);
    }
    else{
      const hostname = ['my.selynk.com','localhost:3002']?.includes(window?.location?.host);
      navigate(hostname ? `/login${pathId ? `/${pathId}` : `/${companyId}`}` : `/login/${companyId}`);
    }
  };

  const trigger = useScrollTrigger({
    disableHysteresis: true,
    threshold: 0,
    target: props.window ? window() : undefined
  });

  const bgC = menuBackgroundColor ? menuBackgroundColor : bgcolor;
  const _bgColor = { backgroundColor: !displayMenuOverHeader ? bgC :  trigger ? bgC : 'transparent' };
  const _menuFontColor = displayMenuOverHeader && trigger ? '#000' : menuFontColor ? menuFontColor : props.defaultColor;
  const _menuActiveFontColor = menuActiveFontColor ? menuActiveFontColor : props.activeColor;
  const filterMenuList = data?.menuList?.filter(v=> v?.visible)?.splice(1) || [];

  const openMenu = () => {
    if(isOpen) {
      toggleOpen();
      setTimeout(()=> setIsOpen(!_isOpen),1000)
    }
    else{
      setIsOpen(!_isOpen);
      setTimeout(()=> toggleOpen(),0)
    }
  }

  return (
      <AppBar
        style={
          props.hasActiveBorderTop || props.paddingZero
            ? { margin: 0, padding: 0,
              ..._bgColor
             }
            : { paddingBottom: '0em',
            ..._bgColor 
          }
        }
        {...(displayMenuOverHeader && {  transition: trigger ? "0.3s" : "0.5s"})}
        position={displayMenuOverHeader ? 'fixed': position}
        zIndex={999}
        color={transparencyColor ? transparencyColor : "transparent"}
      >
        {matches992 ?
          <Box
          // pt={props.hasActiveBorderTop ? 0 : 3}
          // {...(props.fixPadding ? {py:'12px'} : '')}
          display="flex"
          flexWrap="wrap"
          justifyContent="space-between"
          width="100%"
          m="auto"
          height={!matches992 ? props.height : '60px'}
          bgcolor={!displayMenuOverHeader ? bgC : trigger ? bgC : 'transparent'}
          style={isRTL === 'ar' ? {paddingRight:'15px'} : {padddingLeft:'15px'}}
        >
          <Box
            display={matches992 ? 'flex' : 'none'}
            ml="auto"
            justifyContent="flex-start"
            flexDirection={isRTL === 'ar' ? 'row' : 'row'}
            width={matches992 ?'100%' : 'unset'}
            alignItems={{xs:'center'}}
            color={_menuFontColor}
            dir={isRTL === 'ar' ? 'rtl' : 'ltr'}
            position="relative"
          >

            {logo && (
              <Link to={companyDomain ? '/' : `/${pathId}`} style={isRTL === 'ar' ? {paddingRight:'30px'} : {paddingLeft:'30px'}}>
                <Box
                  cursor="pointer"
                  overflow="hidden"
                {...(props.isMobile ? {mx: 'auto'} : isRTL === 'ar' ? {ml:2} : {mr:2})}
                >
                <ImgLazyLoad>
                  <img
                    src={logo}
                    alt="logo"
                    className={classes.imgHover}
                    style={{ height: '100%', maxHeight:'35px', verticalAlign:'middle' }}
                  />
                </ImgLazyLoad>
                </Box>
              </Link>
            )}
        
            <motion.nav
            initial={false}
            animate={isOpen ? "open" : "closed"}
            custom={height}
            ref={containerRef}
            className='nav'
            style={{position:_isOpen ? 'fixed' : 'unset'}}
          >
            <motion.div className="background" variants={isRTL === 'en' ? enSidebar : arSidebar} />
              {_isOpen ?
              <MenuItem 
                menuList={filterMenuList}
                isRTL={isRTL}
                data={data}
                menuActiveFontColor={menuActiveFontColor}
                menuFontColor={menuFontColor}
                open={isOpen}
                _open={_isOpen}
                setOpen={openMenu}
                redirectLogin={redirectRenew}
                {...props}
              />
              : null}

              <MenuToggle toggle={() => openMenu()} isRTL={isRTL} />
            </motion.nav>
          </Box>
        </Box>
        :
          <SectionLayout disableTopPadding disableBottomPadding>
          <Box
            // pt={props.hasActiveBorderTop ? 0 : 3}
            {...(props.fixPadding ? {py:'12px'} : '')}
            display="flex"
            flexWrap="wrap"
            justifyContent="space-between"
            width="100%"
            m="auto"
            height={props.height ? props.height : 'auto'}
            bgcolor={!displayMenuOverHeader ? bgC : trigger ? bgC : 'transparent'}
          > 
          {/* desktop */}
          <Box
            display={!matches992 ? 'flex' : 'none'}
            width="100%"
            flexDirection={'row'}
            flexWrap="wrap"
            justifyContent="space-between"
            alignItems="center"
          >
            <NavLinks
              logo={logo}
              formData={formData}
              setFormData={setFormData}
              {...props}
              setIsOpen={setIsOpen}
              redirectRenew={redirectRenew}
              menuFontColor={_menuFontColor ? _menuFontColor : ""}
              menuActiveFontColor={_menuActiveFontColor}
              direction="row"
            />
          </Box>
          </Box>
          {!displayMenuOverHeader ? props.hasActiveBorder && (
            <Divider
              style={{ width: '100%', backgroundColor: 'white', opacity: '0.6' }}
            />
          )
          : null
          }
          </SectionLayout>
        }
      </AppBar>
  );
};

const mapStateToProps = state => {
  return {
    company_id: state.company_id, // company theme setting
    cartList: state.cartList
  }
};

const mapDispatchToProps = dispatch => {
  return {
    get_user_cart: data => dispatch(getUserCart(data)), // get user cart data
  }
};

export default connect(mapStateToProps,mapDispatchToProps)(Navbar);

export const MenuToggle = ({ toggle,isRTL }) => (
  <button className='_button' onClick={toggle} style={isRTL === 'ar' ? {left:'15px'} : {right:'15px'}}>
    <svg width="23" height="23" viewBox="0 0 23 23">
      <Path
        variants={{
          closed: { d: "M 2 2.5 L 20 2.5" },
          open: { d: "M 3 16.5 L 17 2.5" }
        }}
      />
      <Path
        d="M 2 9.423 L 20 9.423"
        variants={{
          closed: { opacity: 1 },
          open: { opacity: 0 }
        }}
        transition={{ duration: 0.1 }}
      />
      <Path
        variants={{
          closed: { d: "M 2 16.346 L 20 16.346" },
          open: { d: "M 3 2.5 L 17 16.346" }
        }}
      />
    </svg>
  </button>
);

export const MenuItem = ({menuList,isRTL,data, menuActiveFontColor,menuFontColor, open, _open, setOpen, redirectLogin,...props}) => {
  const { companyDomain, t, showMenuLangBtn=true, showMenuLoginBtn=true, user, company } = data || {};
  const params = useParams();
  const { id: pathId } = params;
  const isParent = user && user.isParent;
  const companyId = company && company.id;
  const classes = useStyles();
  const [, , fontFamily] = useRTL();
  const dispatch = useDispatch();

  const changeLanguage = (newLanguage) => {
    dispatch(change_lang(newLanguage));
    i18next.changeLanguage(newLanguage);
  };

  const renderMenuItem = (menuItem,index) => {
    const { englishName, arabicName, visible, externalLink, path, subMenu=[], id } = menuItem;
    const menuExist = subMenu ? subMenu?.filter(v => v?.visible) : false;
    if (!visible) return null; // Return early if not visible
  
    const title = isRTL === 'ar' ? arabicName : englishName;
    const linkPath = path ? companyDomain ? `/temp/${path}` : `/${pathId}/temp/${path}` : '';

    if(id === 'service-1') {
      return(
        <motion.li
        variants={menuItemVariants}
        whileHover={{ scale: 1.1 }}
        whileTap={{ scale: 0.95 }}
        className='li'
        key={index}
      >
        <CustomizedMenus  {...props} menuActiveFontColor={menuActiveFontColor} menuFontColor={menuFontColor} callback={()=> setOpen(false)}/>
      </motion.li>
      )
    };
  
    if (menuExist?.length) {
      return (
        <motion.li
          variants={menuItemVariants}
          whileHover={{ scale: 1.1 }}
          whileTap={{ scale: 0.95 }}
          className='li'
          key={index}
        >
        <DropdownMenuItem
          title={title}
          externalLink={externalLink}
          to={linkPath}
          menuFontColor={menuFontColor}
          menuActiveFontColor={menuActiveFontColor}
          subMenu={menuExist}
          callback={()=> setOpen(false)}
          {...props}
        />
        </motion.li>
      );
    };
  
    return (
      <motion.li
        variants={menuItemVariants}
        whileHover={{ scale: 1.1 }}
        whileTap={{ scale: 0.95 }}
        className='li'
        key={index}
      >
        <MyLink
          externalLink={externalLink}
          to={linkPath}
          menuFontColor={menuFontColor}
          menuActiveFontColor={menuActiveFontColor}
          callback={()=> setOpen(false)}
          {...props}
        >
          {title}
        </MyLink>
      </motion.li>
    );
  };

  const loginClick = async () => {
    setOpen(false);
    redirectLogin();
  }

  // if(_open) 
    return (
    <motion.ul variants={variants} 
    className='ul'
    
    style={{width:open ? 'calc(100% - 40px)' : '230px',...(open ? {overflowY: 'auto'} : {}) }}
    >
        <motion.li
          variants={menuItemVariants}
          whileHover={{ scale: 1.1 }}
          whileTap={{ scale: 0.95 }}
          className='li'
        >
          <MyLink to={companyDomain ? '/' : `/${pathId}`} callback={()=> setOpen(false)} menuFontColor={menuFontColor} menuActiveFontColor={menuActiveFontColor} {...props}>
            {t && t('companyPage.home')}
          </MyLink>

        </motion.li>
        {menuList.map(renderMenuItem)}

        <div style={{display:'flex',flexDirection:'row',alignItems:'center',gap:'1rem',flexWrap:'wrap',width:'100%'}}>
            {showMenuLoginBtn ? 
              <motion.li
                variants={menuItemVariants}
                whileHover={{ scale: 1.1 }}
                whileTap={{ scale: 0.95 }}
                className='li'
              >
                <button className={classes.mobileLoginBtn} onClick={loginClick} style={{fontFamily:'inherit'}}>{t && t(isParent && companyId ? 'parentDashboard.myAccount2' : 'companyPage.login')}</button>
              </motion.li>
            : null}
            {showMenuLangBtn ? 
              <motion.li
                variants={menuItemVariants}
                whileHover={{ scale: 1.1 }}
                whileTap={{ scale: 0.95 }}
                className='li'
              >
                <button className={classes.mobileLoginBtn} onClick={()=> changeLanguage(data.isRTL === 'en' ? 'ar' : 'en')} style={{fontFamily:'inherit',border:'1px solid #0F467A',backgroundColor:'#fff',color:'#0F467A'}}>{data?.isRTL === 'ar' ? 'English' : 'عربي'}</button>
              </motion.li>
            : null}
        </div>  
      </motion.ul>
  );

  // return null;
};

export const useDimensions = ref => {
  const dimensions = useRef({ width: 0, height: 0 });

  useEffect(() => {
    dimensions.current.width = ref?.current?.offsetWidth;
    dimensions.current.height = ref?.current?.offsetHeight;
  }, []);

  return dimensions.current;
};